import React from 'react';
import PropTypes from 'prop-types';
import { HeadingText } from '@paypalcorp/pp-react';
import styles from '../Fastlane.module.less';

export default function QuickStartPaymentSection({ activeSection }) {
  return (
    <>
      <div className={styles.section_heading}>
        <HeadingText size="sm">Payment</HeadingText>
      </div>
      <section
        id="fastlane-payment-sdk-section"
        style={{ display: activeSection === 2 ? 'flex' : 'none' }}
      >
        <div id="payment-component" />
      </section>
    </>
  );
}

QuickStartPaymentSection.propTypes = {
  activeSection: PropTypes.number.isRequired
};
